import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from "vue";
import AssetControlPanel from "@/components/AssetControlPanel.vue";
import { DecoratedAsset } from "@/types";

export interface Props {
  asset: DecoratedAsset;
  indoorUnits?: DecoratedAsset[];
  loading?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OutdoorUnit',
  props: {
    asset: null,
    indoorUnits: { default: () => [] },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {



return { __sfc: true,AssetControlPanel }
}

})